module.exports = __webpack_public_path__ + "media/services_overview/smart-finance-notes-04bdbb47.webp";